import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import ButtonExampleEmphasis from './Button';
import pro from './pro.jpg';
import './aboutme.css';
import './about.js';

class About extends Component {
  render() {
    return(
                    <Grid className="landing-grid" style={{position:'relative',background: 'url(https://i.ibb.co/4WxMS3Y/share.png) center / cover '}}>

            <Cell col={12}>
        

            <div className="banner-text" style={{position:'relative',padding:'100px'}}>
              <h1 class="Text" >Hi.I'm Ahmed Selmi.<br></br>I'm 21.<br></br>Web Developer<br></br><br></br>Looking for<br></br><b><em>PFE Internship</em></b></h1>



 </div> </Cell>
          
        </Grid>

    )
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/aboutme.js